import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import AuthPage from "@/pages/AuthPage";

export default function JoinPage() {
  const { slug } = useParams();
  const [invite, setInvite] = useState(undefined);
  useEffect(() => { api.get(`/invite/${slug}`).then((r) => setInvite(r.data)).catch(() => setInvite(null)); }, [slug]);
  if (invite === undefined) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-pinkb" /></div>;
  if (invite && invite.open) return <AuthPage mode="register" invite={invite} />;
  return (
    <div className="relative z-10 min-h-screen flex items-center justify-center px-6">
      <div className="max-w-md text-center" data-testid="invite-closed">
        <h1 className="text-3xl text-navy">{invite ? "This invite link is full or closed." : "We couldn't find that invite link."}</h1>
        <p className="text-muted-foreground mt-3">Join the waitlist and you'll be first to hear when The Roots Club opens.</p>
        <Link to="/register" data-testid="invite-closed-register-link" className="mt-8 inline-block rounded-full bg-navy text-white px-6 py-2.5 text-sm hover:bg-navy/90 transition-colors">Join the waitlist</Link>
      </div>
    </div>
  );
}
